var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0007 34L33.5554 31.2276C33.8487 29.7612 34.6327 28.4096 34.9123 26.9406C34.9703 26.6359 35.0007 26.3215 35.0007 26C35.0007 23.2386 32.7621 21 30.0007 21C27.2392 21 25.0007 23.2386 25.0007 26C25.0007 26.3215 25.031 26.6359 25.089 26.9406C25.3686 28.4096 26.1526 29.7612 26.446 31.2276L27.0007 34M33.0007 34H27.0007M33.0007 34L37.9932 35.3318C39.75 35.7222 41 37.2804 41 39.0801C41 40.1404 40.1404 41 39.0801 41H37.9932H22H20.9199C19.8596 41 19 40.1404 19 39.0801C19 37.2804 20.25 35.7222 22.0068 35.3318L27.0007 34",
    stroke: "#5784F7",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 15V13C31 7.34315 31 4.51472 29.2426 2.75736C27.4853 1 24.6569 1 19 1H13C7.34315 1 4.51472 1 2.75736 2.75736C1 4.51472 1 7.34315 1 13V29C1 34.6569 1 37.4853 2.75736 39.2426C4.51472 41 7.34315 41 13 41",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.3333C11 14.3333 12.25 14.3333 13.5 17C13.5 17 17.4706 10.3333 21 9",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 25H17",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 31H17",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApproval);
export default __webpack_public_path__ + "static/media/IconApproval.18a3d978feb85c64c6f32f7f01e1cec4.svg";
export { ForwardRef as ReactComponent };